import type { IOrganizationRef } from 'Model/index.js'
import { useSelector } from 'Flux/index.js'
import { createSelector } from '@reduxjs/toolkit'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'

export const useGetOrganizationsOfOrderSelector: () => Record<string, IOrganizationRef> = () => {
  return useSelector(getOrganizations)
}

const selectOrganizations = (state: typeof State) => state[orderSlice.name].organizations

export const getOrganizations = createSelector(selectOrganizations, (orgs) => ({ ...orgs }))
